import React, { useState } from "react";
import ReactModal from "react-modal";
import classNames from "classnames";

import classes from "./style.module.scss";
import "./style.scss";
import { useRemoteConfig } from 'core/hooks/use-remote-config';

if (process.env.NODE_ENV !== "test") {
  try {
    ReactModal.setAppElement("#root");
  } catch {
    try {
      ReactModal.setAppElement("body");
    } catch {}
  }
}

interface Props {
  children: React.ReactNode;
  isOpen: boolean;
  centered?: boolean;
  onCloseModal?: () => void;
  className?: string;
  overlayClassName?: string;
  maxModalHeight?: number | null;
}

const Modal: React.FC<Props> = ({
  children,
  isOpen,
  centered,
  maxModalHeight,
  onCloseModal,
  className,
  overlayClassName,
}) => {
  const [wasOpen, setWasOpen] = useState(false);
  const removeBodyClass = (elementClass: string) =>
    document.body.classList.remove(elementClass);
  const { newPaymentModal } = useRemoteConfig();

  const handleOpenModal = () => {
    setTimeout(() => {
      setWasOpen(true);
    }, 0);
  };

  const handleAfterClose = () => {
    setTimeout(() => {
      setWasOpen(false);
      removeBodyClass("ReactModal__Body--open");
    }, 0);
  };

  return (
    <ReactModal
      style={{
        content: {
          ...(maxModalHeight ? { maxHeight: `${maxModalHeight}px` } : {}),
        },
      }}
      overlayClassName={classNames(classes.overlay, overlayClassName)}
      className={{
        base: classNames(classes.modal, className, {
          [classes.centered]: centered,
          [classes.modalNew]: newPaymentModal

        }),
        afterOpen: classNames({
          [classes["modal-content-after-open"]]: wasOpen,
        }),
        beforeClose: classNames(classes["modal-content-before-close"]),
      }}
      htmlOpenClassName="ReactModal__Html--open"
      onAfterOpen={handleOpenModal}
      onAfterClose={handleAfterClose}
      closeTimeoutMS={500}
      isOpen={isOpen}
      onRequestClose={onCloseModal}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
